<template>
  <div class="custom-empty">
    <div class="custom-empty__wrap" :class="[`custom-empty__wrap--${variant}`]">
      <div class="custom-empty__content">
        <div class="custom-empty__content-title">{{ title }}</div>

        <div v-if="description" class="custom-empty__content-description">{{ description }}</div>

        <button-base v-if="btnText" class="custom-empty__content-btn" type="primary" size="md" @click="onBtnClick">
          {{ btnText }}
        </button-base>
      </div>

      <div class="custom-empty__illustration">
        <atomic-image :src="image" alt="title" />
      </div>
    </div>

    <div v-if="btnText" class="custom-empty__content-btn custom-empty__content-btn--mobile">
      <button-base type="primary" size="md" @click="onBtnClick">
        {{ btnText }}
      </button-base>
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      image: string;
      title: string;
      description?: string;
      btnText?: string;
      link?: string;
      variant?: 'default' | 'variant-1';
    }>(),
    {
      variant: 'default',
      link: '/',
    }
  );

  const emits = defineEmits(['onBtnClick']);

  const { localizePath } = useProjectMethods();

  const onBtnClick = () => {
    emits('onBtnClick');

    if (props.link) {
      navigateTo(localizePath(props.link));
    }
  };
</script>

<style lang="scss" src="~/assets/styles/components/atomic/custom-empty.scss" />
